"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentCountry = void 0;
const endpoints_1 = require("../forms/utils/endpoints");
const axios_1 = require("axios");
const endpoints = new endpoints_1.default;
class CurrentCountry {
    constructor() {
        this.getIP = () => {
            let res = axios_1.default.get(endpoints.countryData).then(r => {
                return JSON.stringify(r.data.current.ip);
            });
            return res;
        };
        this.getCountry = () => {
            let res = axios_1.default.get(endpoints.countryData).then(r => {
                return JSON.stringify(r.data.current.country);
            });
            return res;
        };
    }
}
exports.CurrentCountry = CurrentCountry;
